var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgenciesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(0 -0.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 27,
    height: 27,
    transform: "translate(0 0.15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(4.356 1.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M142.19,0h-7.044a2.691,2.691,0,0,0-2.487,1.669h12.018A2.691,2.691,0,0,0,142.19,0Z",
    transform: "translate(-129.327)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M80.26,64.267H66.955a2.691,2.691,0,0,0-2.688,2.687V85.348a.731.731,0,0,0,.731.731h4.748v-3.47a2.691,2.691,0,0,1,2.688-2.688h2.348a2.69,2.69,0,0,1,2.687,2.688v3.47h4.748a.731.731,0,0,0,.731-.731V66.954a2.691,2.691,0,0,0-2.687-2.687ZM69.428,78.038a.731.731,0,1,1,.214-.517A.736.736,0,0,1,69.428,78.038Zm0-3.131a.731.731,0,1,1,.214-.516A.734.734,0,0,1,69.428,74.907Zm0-3.131a.731.731,0,1,1,.214-.517A.737.737,0,0,1,69.428,71.776Zm0-3.131a.731.731,0,1,1,.214-.517A.736.736,0,0,1,69.428,68.645Zm3.131,9.392a.73.73,0,1,1,.214-.517A.736.736,0,0,1,72.559,78.038Zm0-3.131a.731.731,0,1,1,.214-.516A.735.735,0,0,1,72.559,74.907Zm0-3.131a.732.732,0,1,1,.214-.517A.737.737,0,0,1,72.559,71.776Zm0-3.131a.731.731,0,1,1,.214-.517A.737.737,0,0,1,72.559,68.645Zm3.13,9.392a.73.73,0,1,1,.214-.517A.736.736,0,0,1,75.689,78.038Zm0-3.131a.73.73,0,1,1,.214-.516A.735.735,0,0,1,75.689,74.907Zm-1.247-3.647a.73.73,0,1,1,.214.517A.736.736,0,0,1,74.442,71.259Zm1.247-2.614a.73.73,0,1,1,.214-.517A.735.735,0,0,1,75.689,68.645Zm3.131,9.392a.731.731,0,1,1,.214-.517A.736.736,0,0,1,78.82,78.038Zm0-3.131a.731.731,0,1,1,.214-.516A.734.734,0,0,1,78.82,74.907Zm0-3.131a.731.731,0,1,1,.214-.517A.737.737,0,0,1,78.82,71.776Zm0-3.131a.731.731,0,1,1,.214-.517A.737.737,0,0,1,78.82,68.645Z",
    transform: "translate(-64.267 -61.136)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M271.444,415.6H271v4.7h1.669v-3.47A1.227,1.227,0,0,0,271.444,415.6Z",
    transform: "translate(-260.93 -395.354)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M206.733,416.826v3.47H208.4v-4.7h-.443A1.227,1.227,0,0,0,206.733,416.826Z",
    transform: "translate(-199.793 -395.354)",
    fill: "#a4a4a4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenciesIcon);
export default __webpack_public_path__ + "static/media/agencies-icon.e6585c9b138c93f0f9d1bbe3f335240c.svg";
export { ForwardRef as ReactComponent };